<div class="eqbd-dialog">
  <button type="button" class="btn btn-sm my-1 close-btn" (click)="closeDialog(); $event.stopPropagation()">
    <i class="bi bi-x-circle"></i>
  </button>

  <h2 mat-dialog-title>{{ data.message }}</h2>

  <mat-dialog-actions>
    <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onAmendQuote()">
      {{ data.confirmText || 'Amend Quote' }}
    </button>
    <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onCancel()">
      {{ data.cancelText || 'Cancel' }}
    </button>
  </mat-dialog-actions>
</div>
